import { BudgetFieldValueDto } from 'api/budgets/models/BudgetDto';
import { BudgetFieldDto } from 'api/budgetsFields/models/BudgetFieldDto';

// Versão visível ao utilizador: inteiros sem casas decimais (1), decimais com uma casa (0.1).
export const formatBudgetVersion = (version?: number | null): string => {
    if (version == null) return '';
    return Number.isInteger(version) ? String(version) : version.toFixed(1);
};

export const mapFieldValues = (budgetsFields: BudgetFieldDto[], fieldsValues: BudgetFieldValueDto[]): BudgetFieldValueDto[] => {
    return budgetsFields.map(bf => {
        const fv = fieldsValues.find(x => x.budgetFieldId === bf.id);
        return ({
            budgetFieldId: bf.id,
            value: fv?.value ?? null,
            budgetFieldOptionId: fv?.budgetFieldOptionId ?? null,
            name: bf.name,
            isRequired: bf.isRequired,
            fieldType: bf.fieldType,
            options: bf.options,
        });
    });
}
